document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.search-by-type').forEach(el => {
    new Tabs({
      scope: el,
      tabs: el.querySelectorAll('.search-by-type__tab'),
      contents: el.querySelectorAll('.search-by-type__tabs-content-item'),
      tabActiveClass: 'search-by-type__tab--active',
      contentActiveClass: 'search-by-type__tabs-content-item--active',
      activateFirst: false
    });
  });
});